import { get } from 'lodash';

import { Service } from '../types';

const isOauth = (service: Service) => {
  const authType = get(service, 'authType', null);
  const oauthService = get(service, ['meta', 'oauth'], false);
  return authType === 'oauth' || oauthService;
};

export default isOauth;
